import { APP_ROOT_ELEMENT } from '@/constants';
import type { AppContext, SitecoreContextData } from '@/types';

export const initialAppContext: AppContext = {
    cssLabel: '',
    proposition: '',
    routerBase: '',
    sitecoreApiHost: '',
    sitecoreBasePath: '',
    sitecoreSiteName: '',
    sitecoreVirtualFolder: '/',
    startPath: ''
};

export const createClientAppContext = (elementId = APP_ROOT_ELEMENT): AppContext => {
    const appContext = { ...initialAppContext };
    const element = document.getElementById(elementId);

    if (element) {
        for (const key in element.dataset) {
            if (typeof key === 'string') {
                const k = key as keyof AppContext;

                appContext[k] = element.dataset[key] as AppContext[typeof k];
            }
        }
    }

    return appContext;
};

export const createServerAppContext = (state: {
    viewBag: unknown;
    sitecore: { context: SitecoreContextData };
}): AppContext => {
    const { context } = state.sitecore;

    return {
        ...initialAppContext,
        cssLabel: getLabel(context),
        sitecoreBasePath: context.pageEditing ? '/' : context.application.sitecorePath,
        sitecoreSiteName: context.site.name
    };
};

export const getLabel = (context: SitecoreContextData) => {
    const sites = ['dechristelijkezorgverzekeraar', 'defriesland', 'ziezo', 'zilverenkruis'];
    const siteName = context.site.name;

    if (siteName === 'zilverenkruis') {
        const sitecorePath = context.application.sitecorePath;

        if (sitecorePath.includes('ziezo')) {
            return 'ziezo';
        }
    }

    if (sites.indexOf(siteName) > -1) {
        return siteName;
    }

    return '';
};

export const createDataAttributesFromAppContext = (appContext: AppContext) =>
    Object.keys(appContext).reduce(
        (acc, curr) =>
            `${
                acc
            } data-${curr.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()}="${appContext[curr as keyof AppContext]}"`,
        ''
    );
